import { render, staticRenderFns } from "./login.vue?vue&type=template&id=52184324"
import script from "./login.ts?vue&type=script&lang=js&external"
export * from "./login.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/1/s/TafStore.PharmUP.Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52184324')) {
      api.createRecord('52184324', component.options)
    } else {
      api.reload('52184324', component.options)
    }
    module.hot.accept("./login.vue?vue&type=template&id=52184324", function () {
      api.rerender('52184324', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parent/login/login.vue"
export default component.exports